//-----------------------------|| LIST ||---------------------------------------------------------------
export const SET_LAB_RECORD_LIST = 'SET_LAB_RECORD_LIST';
export const CLEAR_LAB_RECORD_LIST = 'CLEAR_LAB_RECORD_LIST';
export const LAB_RECORD_LIST_PENDING = 'LAB_RECORD_LIST_PENDING';
export const LAB_RECORD_LIST_ERROR = 'LAB_RECORD_LIST_ERROR';
export const LAB_RECORD_LIST_ERROR_CLEAR = 'LAB_RECORD_LIST_ERROR_CLEAR';

//-----------------------------|| FILTER ||-------------------------------------------------------------
export const LAB_RECORDS_FILTER_DIALOG_OPEN = 'LAB_RECORDS_FILTER_DIALOG_OPEN';
export const LAB_RECORDS_FILTER_DIALOG_CLOSE = 'LAB_RECORDS_FILTER_DIALOG_CLOSE';
export const SET_LAB_RECORDS_FILTER_DATA = 'SET_LAB_RECORDS_FILTER_DATA';

//-----------------------------|| DETAILS ||------------------------------------------------------------
export const SET_LAB_RECORD_DETAILS = 'SET_LAB_RECORD_DETAILS';
export const CLEAR_LAB_RECORD_DETAILS = 'CLEAR_LAB_RECORD_DETAILS';
export const LAB_RECORD_DETAILS_PENDING = 'LAB_RECORD_DETAILS_PENDING';
export const LAB_RECORD_DETAILS_ERROR = 'LAB_RECORD_DETAILS_ERROR';
export const LAB_RECORD_DETAILS_ERROR_CLEAR = 'LAB_RECORD_DETAILS_ERROR_CLEAR';

//-----------------------------|| CREATE ||-------------------------------------------------------------
export const LAB_RECORD_CREATE_DIALOG_OPEN = 'LAB_RECORD_CREATE_DIALOG_OPEN';
export const LAB_RECORD_CREATE_DIALOG_CLOSE = 'LAB_RECORD_CREATE_DIALOG_CLOSE';
export const LAB_RECORD_CREATE_PENDING = 'LAB_RECORD_CREATE_PENDING';
export const LAB_RECORD_CREATE_ERROR = 'LAB_RECORD_CREATE_ERROR';
export const LAB_RECORD_CREATE_ERROR_CLEAR = 'LAB_RECORD_CREATE_ERROR_CLEAR';

//-----------------------------|| EDIT ||---------------------------------------------------------------
export const LAB_RECORD_EDIT_DIALOG_OPEN = 'LAB_RECORD_EDIT_DIALOG_OPEN';
export const LAB_RECORD_EDIT_DIALOG_CLOSE = 'LAB_RECORD_EDIT_DIALOG_CLOSE';
export const LAB_RECORD_EDIT_PENDING = 'LAB_RECORD_EDIT_PENDING';
export const LAB_RECORD_EDIT_ERROR = 'LAB_RECORD_EDIT_ERROR';
export const LAB_RECORD_EDIT_ERROR_CLEAR = 'LAB_RECORD_EDIT_ERROR_CLEAR';